import { Pipe, PipeTransform } from '@angular/core';

import { isArray } from '@core/helpers';

@Pipe({
  name: 'sort'
})
export class SortPipe  implements PipeTransform {
  public transform(array: any, field: string): any[] {
    if (!isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
